function init () {
  /* 显示隐藏 */
  function fadeIn (show) {
    $(show).fadeIn()
  }
  function fadeOut (hide) {
    $(hide).fadeOut()
  }

  $(function () {
    /* 登录切换 */
    loadTab()
  })

  function resetTabs (obj) {
    $(obj).parent().parent().next('div').find('div').hide()
    $(obj).parent().parent().find('a').removeClass('current')
  }
  function loadTab () {
    $('.tab_content > div').hide()
    $('.tabs').each(function () {
      $(this).find('li:first a').addClass('current')
    })
    $('.tab_content').each(function () {
      $(this).find('div:first').fadeIn()
    })
    $('.tabs a').on('click', function (e) {
      e.preventDefault()
      if ($(this).attr('class') === 'current') {

      } else {
        resetTabs(this)
        $(this).addClass('current')
        $($(this).attr('name')).fadeIn()
      }
    })
  }
}

export {
  init
}



// WEBPACK FOOTER //
// ./src/assets/js/public_mem.js